/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Recorder_Microphone_LabelInputs */

const en_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Microphone ${i?.index}`)
};

const fr_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Microphone ${i?.index}`)
};

const de_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mikrofon ${i?.index}`)
};

const it_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Microfono ${i?.index}`)
};

const ru_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Микрофон ${i?.index}`)
};

const es_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Micrófono ${i?.index}`)
};

const zh_cn2_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`麦克风 ${i?.index}`)
};

const ja_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マイク ${i?.index}`)
};

const hi_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`माइक्रोफ़ोन ${i?.index}`)
};

const pt_pt2_audio_recorder_microphone_label = /** @type {(inputs: Audio_Recorder_Microphone_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Microfone ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Microphone {index}" |
*
* @param {Audio_Recorder_Microphone_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_microphone_label = /** @type {((inputs: Audio_Recorder_Microphone_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Microphone_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_microphone_label(inputs)
	if (locale === "de") return de_audio_recorder_microphone_label(inputs)
	if (locale === "it") return it_audio_recorder_microphone_label(inputs)
	if (locale === "ru") return ru_audio_recorder_microphone_label(inputs)
	if (locale === "es") return es_audio_recorder_microphone_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_microphone_label(inputs)
	if (locale === "ja") return ja_audio_recorder_microphone_label(inputs)
	if (locale === "hi") return hi_audio_recorder_microphone_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_microphone_label(inputs)
	return en_audio_recorder_microphone_label(inputs)
});